import {Component, ViewChild} from '@angular/core';

import {HomePage} from './home/home';
import {FindClassPage} from './find-class/find-class';
import {ProfilePage} from './profile/profile';
import {MyClassesPage} from './my-classes/my-classes';
import {BeautyPage} from './beauty/beauty';
import {App, Tabs} from 'ionic-angular';
import {SessionService} from '../../services/session';
import {TabsService} from './tabs.service';
import {MembershipService} from './profile/membership/membership.service';
import {AuthService} from '../../services/auth';
import {IonicTokenService} from '@fitpass/ionic-token-auth';
import {BackendModule} from '../../modules/backend.module';
import {SignInPage} from '../auth/sign-in/sign-in';
import { MishiService } from '../../services/mishi';

@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {
  homePage = HomePage;
  findClassPage = FindClassPage;
  profilePage = ProfilePage;
  myClassesPage = MyClassesPage;
  beautyPage = BeautyPage;
  signinPage = SignInPage;
  isBeautyEnabled = true;
  isLoaded = false;

  @ViewChild('myTabs') tabRef: Tabs;

  constructor(public sessionService: SessionService,
              public app: App,
              public authService: AuthService,
              private tokenService: IonicTokenService,
              private backendModule: BackendModule,
              public memberService: MembershipService,
              public mishiService: MishiService,
              public tabsService: TabsService) {
  }

  ionViewWillEnter() {
  }

  ionViewDidLoad() {
    this.tabsService.setBackgroundColor(false);
    this.isLoaded = true; // HACK! need it to preserve Tab order for beauty and profile

    if (this.sessionService.user !== null) {
      this.mishiService.loadSearchBanner();

      console.log('=> TabsPage: startIntervalForHomeBanner');
      this.mishiService.startIntervalForHomeBanner();

      this.isBeautyEnabled = this.sessionService.user.beauty;
    }

    console.log('=> TABS PAGE LOADED', this.sessionService.user);
  }

  tabChanged() {
    const selectedTab = this.tabRef.getSelected();

    if (selectedTab) {
      const meta = document.querySelector('meta[name="theme-color"]');
      console.log('=> TAB SELECTED', selectedTab, meta);
      this.tabsService.setBackgroundColor(selectedTab.tabIcon === 'fitpass-beauty')
    }
  }


  ngOnInit() {
  }

  ngOnDestroy() {
    console.log('=> TabsPage: stopIntervalForHomeBanner');
    this.mishiService.stopIntervalForHomeBanner();
  }

  onLogOut() {
    setTimeout(() => {
      this.authService.logOut();
      this.app.getRootNav().setRoot(this.signinPage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts